// lib
import * as styles from 'lib/styles/styles';
// icons
import { NextIcon, PrevIcon } from 'lib/svg';
import styled from 'styled-components';

const MoveBtn = ({ type, onClick }: Props) => {
  const Icon = type === "PREV"
    ? PrevIcon
    : NextIcon;
  
  const msg = type === "PREV"
    ? "Previous"
    : "Next";

  return (
    <Container onClick={onClick} title={msg}>
      <Content>
        <Icon />
      </Content>
    </Container>
  );
}

const Container = styled.button`
  min-width: 80px;
  height: 100%;
   background-color: #FF8126;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  
  &:focus, &:hover {
    filter: invert(40%) sepia(85%) saturate(1256%) hue-rotate(210deg) brightness(113%) contrast(101%);
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .1s ${styles.transition};
  
  & > svg {
    width: 30px;
    height: 30px;
  }
`;

interface Props {
  type: "PREV" | "NEXT"
  onClick: () => void;
}

export default MoveBtn;